import React from 'react'
import { observer } from 'mobx-react'
import JobEvent from 'components/JobEvent'
import './styles.sass'

export default observer(function ({ events }) {
  if (events.length === 0) {
    return (
      <div className="no-events">
        <div className="no-events__title">
          Events
        </div>
        <div className="no-events__description">
          <p>
            The fact that you are seeing this message
            means your job was created prior the Event system.
          </p>
          <p>
            Don't worry, this isn't a problem!
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="job-events">
      {events.map(e =>
        <JobEvent key={e.id} event={e} />
      )}
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/client/screens/ProjectDetails/Events/index.jsx